import { createFileRoute } from '@tanstack/react-router';

import { PreSeasonTable } from '../../../new/tables/pre-season';

export const Route = createFileRoute('/new/pre-season/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PreSeasonTable />;
}
